import { apiClient } from '@/shared/lib/axios';
import { Holiday, HolidayQuery } from '@/types/admin-holiday';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

type ApiResponse = {
  success: boolean;
  data: Holiday[];
  message: string;
};

export const getHolidayList = async (
  siteType: string,
  query?: HolidayQuery
): Promise<ApiResponse> => {
  const response = await apiClient.get<ApiResponse>(`/admin/${siteType}/holidays`, {
    params: query,
  });
  return response.data;
};

export const useAdminHolidayList = (query: HolidayQuery) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['holidays', currentSite, query],
    queryFn: () => getHolidayList(currentSite, query),
    select: res => res.data,
  });
};
